var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorrectCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_400_366947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9459 5.96792C14.1353 5.72168 14.0892 5.36852 13.843 5.17911C13.5967 4.9897 13.2436 5.03576 13.0541 5.282L7.81975 12.0867L4.89775 9.16471C4.67808 8.94504 4.32192 8.94504 4.10225 9.16471C3.88258 9.38438 3.88258 9.74054 4.10225 9.96021L7.47725 13.3352C7.59171 13.4497 7.74993 13.5093 7.91145 13.4988C8.07298 13.4883 8.22216 13.4087 8.32085 13.2804L13.9459 5.96792Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM16.875 9C16.875 13.3492 13.3492 16.875 9 16.875C4.65076 16.875 1.125 13.3492 1.125 9C1.125 4.65076 4.65076 1.125 9 1.125C13.3492 1.125 16.875 4.65076 16.875 9Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_400_366947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#268543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrectCircle);
export default __webpack_public_path__ + "static/media/icon-correct-circle.b1e8a5c1f667e64788a7dd2797318bac.svg";
export { ForwardRef as ReactComponent };